/**
 * Helpers para resolver textos bilingües que viven en columnas duales del
 * backend (campo `name` en EN + `nameTranslation` en ES, patrón que sigue
 * ConversationPractice y ahora también Category).
 *
 * Uso típico:
 *   const label = localizedField(category, 'name', i18n.language);
 *
 * Fallback: si el idioma activo no es 'es' o si la traducción está vacía,
 * devuelve el valor base. Nunca devuelve null/undefined; el llamante puede
 * confiar en string.
 */

type LocalizedRecord<Key extends string> = {
  [K in Key]?: string | null;
} & {
  [K in `${Key}Translation`]?: string | null;
};

export function localizedField<Key extends string>(
  obj: LocalizedRecord<Key> | null | undefined,
  baseKey: Key,
  locale: string,
): string {
  if (!obj) return '';
  const record = obj as Record<string, string | null | undefined>;
  const base = record[baseKey] ?? '';
  const translated = record[`${baseKey}Translation`] ?? '';
  if (locale.startsWith('es') && translated.trim().length > 0) return translated;
  return base;
}
